import { createFileRoute } from '@tanstack/react-router';
import { FormAnalyticsPage } from '@/pages/forms/analytics/FormAnalyticsPage';
import { requireAnyPermission } from '@/lib/route-guards/permission-guard';

export const Route = createFileRoute('/_authenticated/_app/forms/$formId/analytics')({
	beforeLoad: ({ context }) =>
		requireAnyPermission({
			context,
			anyOf: ['forms.readAnalytics.own', 'forms.readAnalytics.all'],
			redirectTo: '/forms',
		}),
	component: FormAnalyticsPage,
});
